// extracted by mini-css-extract-plugin
export default {"container":"Ok-z","blurb":"Pk-z","links":"Qk-z"};